import React, { Component } from "react";
import { Form } from "react-bootstrap";

import { FormControl } from "../../../../facturotopia";
import DecimalForConceptos from "../../support/impuestos/DecimalForConceptos";

class PersonalizarDecimales extends Component {
  state = {};

  handleOnDecimalsChange = (value) => {
    DecimalForConceptos.decimales = parseInt(value.Decimales);

    this.props.onChange(value);
  }

  render() {
    const { data } = this.props;

    return (
      <Form autoComplete="off">
        <FormControl
          type="select"
          label="Personalizar Decimales"
          name="Decimales"
          placeholder=""
          help="Cálculo de decimales para conceptos de la factura"
          value={ data.Decimales }
          options={ decimalesOptions }
          onChange={ this.handleOnDecimalsChange }
        />
      </Form>
    );
  }
}

const decimalesOptions = [
  {
    label: '2',
    value: 2
  },
  {
    label: '3',
    value: 3
  },
  {
    label: '4',
    value: 4
  },
  {
    label: '5',
    value: 5
  },
  {
    label: '6',
    value: 6
  }
];

export default PersonalizarDecimales;
